/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Notifications_Empty_Subtitle1Inputs */

const en_coinvestments_notifications_empty_subtitle1 = /** @type {(inputs: Coinvestments_Notifications_Empty_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications about your co-investment deals will appear here`)
};

/**
* | output |
* | --- |
* | "Notifications about your co-investment deals will appear here" |
*
* @param {Coinvestments_Notifications_Empty_Subtitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_notifications_empty_subtitle1 = /** @type {((inputs?: Coinvestments_Notifications_Empty_Subtitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Notifications_Empty_Subtitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_notifications_empty_subtitle1(inputs)
});
export { coinvestments_notifications_empty_subtitle1 as "coInvestments_notifications_empty_subtitle" }